export enum ApplicationFormSchemaCategories {
  MDM = 'mdm',
  IDP = 'idp',
  DATA = 'data',
  SHADOW_SAAS = 'shadow_saas',
  CORE_APPLICATION = 'core_application',
}
